const LangSwitcher = () => {

    document.addEventListener('DOMContentLoaded', function () {
        const switcher = document.querySelector('.lang-switcher');
        const button = switcher.querySelector('.lang-switcher__button');
    
        button.addEventListener('click', function (e) {
            e.preventDefault();
            switcher.classList.toggle('open');
        });
    
        document.addEventListener('click', function (e) {
            if (!switcher.contains(e.target)) {
                switcher.classList.remove('open');
            }
        });
    });
};

export default LangSwitcher;
